import React, { useCallback } from 'react';
import { AppButton, Box, Text } from '@common-fe/common-fe';

interface Props {
  src: string;
  testId: string;
}

const ResendListItemLetterPreview :React.FC<Props> = ({ src, testId }) => {
  const handleOpen = useCallback(() => {
    window.open(src);
  }, [src]);
  return (
    <Box
      direction='column' 
      data-testid={testId}
    >
      <Box direction="row" align="center" justify="between">
        <Text size="xxlarge" weight={400}>
          Sent message
        </Text>
        <AppButton testId={testId} buttonType="secondary" width="168px" onClick={handleOpen}>
          Show Preview
              
        </AppButton>
      </Box>
     
    </Box>
  );
};

export default ResendListItemLetterPreview;